const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/newsletter/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { newsletterQueries } from "@circle-react/lib/queries/newsletters";
import { punditUserQueries } from "@circle-react/lib/queries/punditUser";
import { newsletterHomePath, newsletterRoutes } from "@circle-react/lib/routes/newsletter";
import { createFileRoute, redirect } from "@tanstack/react-router";
const ACTIVATE_PATH = newsletterRoutes.activate();
const isActivatePath = (pathname: string) => pathname.replace(/\/+$/, "") === ACTIVATE_PATH;
export const Route = createFileRoute("/_protected/_settingsLayout/settings/newsletter")({
  beforeLoad: async ({
    context,
    location
  }) => {
    const punditUserContext = context.punditUserContext;
    const isAdmin = !!punditUserContext?.currentCommunityMember?.is_admin;
    const isEnabled = !!punditUserContext?.currentCommunitySettings?.email_hub_newsletter_phase_a_enabled;

    // Match collapsed/nested nav: admin + feature flag only.
    if (!isAdmin || !isEnabled) {
      // context.punditUserContext can be a stale localStorage copy (e.g. right
      // after the flag is enabled), so confirm on a fresh fetch before leaving.
      const punditUser = await context.queryClient.fetchQuery({
        ...punditUserQueries.show(),
        staleTime: 0
      }).catch(() => undefined);
      const isAvailable = !!punditUser?.current_community_member?.is_admin && !!punditUser.current_community_settings?.email_hub_newsletter_phase_a_enabled;
      if (!isAvailable) {
        redirect({
          to: "/",
          replace: true,
          throw: true
        });
      }
    }
    const newsletters = await context.queryClient.ensureQueryData(newsletterQueries.list()).catch(() => undefined);
    if (!newsletters) return;
    const isActivated = newsletters.length > 0;
    const isOnActivatePage = isActivatePath(location.pathname);
    if (!isActivated && !isOnActivatePage) {
      redirect({
        to: ACTIVATE_PATH,
        replace: true,
        throw: true
      });
    }
    if (isActivated && isOnActivatePage) {
      const isOverviewEnabled = !!punditUserContext?.currentCommunitySettings?.email_hub_newsletter_phase_e_enabled;
      redirect({
        to: newsletterHomePath(isOverviewEnabled),
        replace: true,
        throw: true
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});